export default [
  [`Размер`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [
    `Российский размер`,
    `42-44`,
    `44-46`,
    `48-50`,
    `50-52`,
    `52-54`,
    `54-56`,
    `58-60`
  ],
  [`Полуобхват в груди, см`, `46`, `48`, `50`, `52`, `54`, `56`, `58`],
  [`Длина, см`, `66`, `68`, `68`, `70`, `70`, `72`, `72`]
];
